//=====================================================
//　メールアドレス補足
//=====================================================

import { useContext } from "react";
import { CtxClinicInfo } from "../utils/Contexts";

export function NotesMail(){

    const cci = useContext(CtxClinicInfo);

    return (
        <div className="about-mail-box">
            <div className="about-mail-box-title"><span className="icon-problem"></span>メールアドレスの設定について</div>
            <div className="about-mail-box-text text-s">
                <b>携帯電話のアドレスをご登録の方</b><br/>
                フィルタリング機能により当システムからのメールを受信できない場合がございます。<br/>
                当システムのメールアドレス
                「<span className="system-mail-address">{cci.data.receiveSettingEmail ? cci.data.receiveSettingEmail : "stransa.co.jp"}</span>」
                を指定受信設定してください。<br/>
                お使いの携帯電話会社によって設定方法が異なります。<br/>
                <a href="https://www.nttdocomo.co.jp/info/spam_mail/domain/" target="_blank" rel="noreferrer">NTTドコモ公式サイト</a> | 
                <a href="https://www.au.com/support/service/mobile/trouble/mail/email/filter/detail/domain/" target="_blank" rel="noreferrer">au公式サイト</a> | 
                <a href="https://www.softbank.jp/mobile/support/antispam/settings/whiteblack/" target="_blank" rel="noreferrer">Softbank公式サイト</a>
            </div>
            <div className="about-mail-box-text text-s">
                <b>Yahoo!などのフリーメールをご利用の方</b><br/>
                当システムからのメールが「迷惑メール」に入ってしまう可能性があります。<br/>
                万が一メールが届かない場合は迷惑メール内をご確認ください。
            </div>
        </div>
    );

}